/*
i y         ɨ ʉ       ɯ u
      ɪ ʏ          ʊ
    e ø       ɘ ɵ     ɤ o
      e̞ ø̞       ə     ɤ̞ o̞
        ɛ œ     ɜ ɞ   ʌ ɔ
          æ       ɐ
            a ɶ       ɑ ɒ
*/

import { IpaVowelRow } from "./Ipa";
import { IpaChartProps } from "./IpaChart";

interface VowelChartProps extends IpaChartProps {
  /** show 'front back' header in the table */
  readonly showFrontBack?: boolean;
};

/** show IPA vowel chart */
export function VowelChart(props: VowelChartProps) {
  return (
    <table>
      {props.showFrontBack ? <FrontBackHeader /> : undefined}
      <tbody>
        <IpaVowelRow symbols={'i y         ɨ ʉ       ɯ u'} title={'Close'} chartProps={props} />
        <IpaVowelRow symbols={'  ɪ ʏ          ʊ'} title={''} chartProps={props} />
        <IpaVowelRow symbols={'    e ø       ɘ ɵ     ɤ o'} title={'Close-mid'} chartProps={props} />
        <IpaVowelRow symbols={'      e̞ ø̞       ə      ɤ̞ o̞'} title={''} chartProps={props} />
        <IpaVowelRow symbols={'        ɛ œ     ɜ ɞ   ʌ ɔ'} title={'Open-mid'} chartProps={props} />
        <IpaVowelRow symbols={'          æ       ɐ'} title={''} chartProps={props} />
        <IpaVowelRow symbols={'            a ɶ       ɑ ɒ'} title={'Open'} chartProps={props} />
      </tbody>
    </table>
  )
}

function FrontBackHeader() {
  return (<thead><tr>
    <th></th>
    <th>&nbsp;front&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;back</th>
  </tr></thead>);
}
